import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface TextWithLinksProps extends Omit<TypographyProps, 'children'> {
  text: string;
}

const TextWithLinks: React.FC<TextWithLinksProps> = ({ text, ...typographyProps }) => {
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Split text by URLs and create array of text and link parts
  const parts = text.split(urlRegex);
  
  return (
    <Typography {...typographyProps}>
      {parts.map((part, index) => {
        // Check if this part is a URL
        if (urlRegex.test(part)) {
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'inherit',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
              }}
            >
              {part}
            </a>
          );
        }
        // Regular text
        return part;
      })}
    </Typography>
  );
};

export default TextWithLinks;

